export default __webpack_public_path__ + "static/media/heart-unliked.e2361c0e.svg";